/* Hut seasonal effects — original vectors, no dependencies. */
(function(global){
  'use strict';
  const config={
    spring:{label:'春',months:[3,4,5],day:'#f2eeee',night:'#28242e',count:12,speed:.028,smoke:.8,wind:1},
    summer:{label:'夏',months:[6,7,8],day:'#edf0e9',night:'#1c2929',count:4,speed:.022,smoke:.28,wind:.85},
    autumn:{label:'秋',months:[9,10,11],day:'#f1ece4',night:'#2c2625',count:11,speed:.040,smoke:1,wind:1.4},
    winter:{label:'冬',months:[12,1,2],day:'#e9edf1',night:'#1e2835',count:42,speed:.035,smoke:1.5,wind:.7}
  };
  function seasonForDate(date=new Date()){
    if(Number.isNaN(date.getTime()))throw new TypeError('Invalid date');
    const month=Number(new Intl.DateTimeFormat('en-US',{timeZone:'Asia/Tokyo',month:'numeric'}).format(date));
    return Object.keys(config).find(k=>config[k].months.includes(month));
  }
  const PERIODS=['day','dusk','night'];
  const PERIOD_WORDS={day:{now:'昼',next:'夕方'},dusk:{now:'夕方',next:'夜'},night:{now:'夜',next:'昼'}};
  function periodForDate(date=new Date()){
    if(Number.isNaN(date.getTime()))throw new TypeError('Invalid date');
    const hour=Number(new Intl.DateTimeFormat('en-GB',{timeZone:'Asia/Tokyo',hour:'numeric',hourCycle:'h23'}).format(date));
    if(hour>=6&&hour<16)return 'day';
    if(hour>=16&&hour<19)return 'dusk';
    return 'night';
  }
  function nextPeriod(current){
    const index=PERIODS.indexOf(current);
    return PERIODS[(index+1)%PERIODS.length];
  }
  function periodSwitchLabel(current){
    const words=PERIOD_WORDS[current]||PERIOD_WORDS.day;
    return '現在は'+words.now+'。'+words.next+'に切り替える';
  }
  function create(assetSources,onReady=()=>{}){
    const images={};let pending=Object.keys(assetSources).length;
    const ready=new Promise(resolve=>{if(!pending){resolve();return;}Object.entries(assetSources).forEach(([key,src])=>{const img=new Image();images[key]=img;const done=()=>{if(!--pending){resolve();onReady();}};img.onload=done;img.onerror=done;img.src=src;});});
    function sprite(ctx,id,x,y,w,rotation=0,alpha=1,squash=1){
      const img=images[id];if(!img||!img.complete||!img.naturalWidth)return;
      ctx.save();ctx.globalAlpha=alpha;ctx.translate(x,y);ctx.rotate(rotation);ctx.scale(squash,1);const h=w*img.naturalHeight/img.naturalWidth;ctx.drawImage(img,-w/2,-h/2,w,h);ctx.restore();
    }
    // Decorative seasonal skies, not an astronomical sky map.
    const starStyles={
      spring:{count:28,alpha:.43,color:'#e2dbcd',size:1.15},
      summer:{count:62,alpha:.40,color:'#d2ddd9',size:1.1},
      autumn:{count:39,alpha:.61,color:'#e4decf',size:1.2},
      winter:{count:58,alpha:.73,color:'#e0e9ef',size:1.35}
    };
    function drawStars(ctx,season,t,reduced){
      const style=starStyles[season];let seed=1729;
      const random=()=>{seed=(seed*16807)%2147483647;return seed/2147483647;};
      ctx.save();ctx.fillStyle=style.color;ctx.strokeStyle=style.color;
      for(let i=0;i<style.count;i++){
        let x=15+random()*744,y=-106+random()*240;
        if(season==='summer'&&i>=28){x=25+random()*720;y=-93+x*.21+(random()-.5)*45;}
        const size=(.45+random()*.65)*style.size;
        const phase=random()*Math.PI*2;
        let alpha=style.alpha*(.48+random()*.52)*(reduced?1:.85+.15*Math.sin(t*.45+phase));
        if(season==='summer'){
          const age=t%12;
          if((age<4.4&&Math.hypot(x-155,y+20)<100)||(age>4.5&&age<8.9&&Math.hypot(x-614,y+8)<90))alpha*=.45;
        }
        ctx.globalAlpha=alpha;
        ctx.beginPath();ctx.arc(x,y,size,0,Math.PI*2);ctx.fill();
        if(i%13===0){
          ctx.globalAlpha=alpha*.7;ctx.lineWidth=.65;
          ctx.beginPath();ctx.moveTo(x-size*2.7,y);ctx.lineTo(x+size*2.7,y);ctx.moveTo(x,y-size*2.7);ctx.lineTo(x,y+size*2.7);ctx.stroke();
        }
      }
      ctx.restore();
    }
    function drawFireworks(ctx,t,reduced){
      const cycle=12;
      for(let k=0;k<2;k++){
        const age=reduced?1.8:((t+cycle-k*4.5)%cycle);
        const cx=k?614:155,cy=k?-8:-20;
        ctx.save();ctx.strokeStyle=k?'#c6cfbe':'#dbc9a3';ctx.lineCap='round';
        if(age<1.1){
          const y=135-(135-cy)*age/1.1;
          ctx.globalAlpha=.65;ctx.lineWidth=1.3;ctx.beginPath();ctx.moveTo(cx,y+13);ctx.lineTo(cx+Math.sin(age*9)*1.5,y);ctx.stroke();
        }else if(age<4.4){
          const p=(age-1.1)/3.3;
          const radius=(1-Math.pow(1-p,3))*(k?58:72);
          const fall=p*p*23;
          ctx.globalAlpha=Math.min(1,p*12)*Math.pow(1-p,.7)*.85;
          for(let j=0;j<32;j++){
            const angle=j/32*Math.PI*2+k*.14;
            const rr=radius*(.9+.1*Math.sin(j*7));
            const tail=Math.max(2,9*(1-p));
            ctx.lineWidth=j%3===0?1.7:1.1;
            ctx.beginPath();ctx.moveTo(cx+Math.cos(angle)*(rr-tail),cy+Math.sin(angle)*(rr-tail)+fall);
            ctx.lineTo(cx+Math.cos(angle)*rr,cy+Math.sin(angle)*rr+fall);ctx.stroke();
            if(j%2===0){ctx.beginPath();ctx.moveTo(cx+Math.cos(angle)*rr*.57,cy+Math.sin(angle)*rr*.57+fall);ctx.lineTo(cx+Math.cos(angle)*(rr*.57+2),cy+Math.sin(angle)*(rr*.57+2)+fall);ctx.stroke();}
          }
        }
        ctx.restore();
      }
    }
    function draw(ctx,{season,night,time,layer='front',reduced=false,gust=0}){
      const c=config[season];if(!c)return;const t=reduced?0:time;
      if(layer==='back'){
        if(night)drawStars(ctx,season,t,reduced);
        if(season==='summer'){
          sprite(ctx,'summer-cloud',((740+t*11)%1074)-150,56,148,0,night?.13:.9);
          sprite(ctx,'summer-cloud',((253+t*7)%1074)-150,117,104,0,night?.08:.65);
        }
        if(season==='summer'&&night)drawFireworks(ctx,t,reduced);
        if(season==='spring'){
          const id=season==='spring'?'spring-cherry-tree':'summer-green-tree';
          for(const [x,y,w] of [[49,350,139],[708,301,145],[760,357,86]]){
            ctx.save();ctx.translate(x,y+w*225/220/2);ctx.rotate(Math.sin(t*.7+x)*.012+Math.sin(t*2)*gust*.02);
            sprite(ctx,id,0,-w*225/220/2,w,0,night?.64:1);ctx.restore();
          }
        }
        return;
      }
      if(season==='summer'){
        ctx.save();ctx.translate(628,248);ctx.rotate(reduced?0:Math.sin(t*2.8)*(.08+gust*.4));
        sprite(ctx,'summer-wind-chime',0,37,34);ctx.restore();
      }
      if(season==='winter'){
        sprite(ctx,'winter-snowman',705,411,95);
        const roof=images['winter-snow-roof'];if(roof?.complete&&roof.naturalWidth)ctx.drawImage(roof,0,0,774,473);
      }
      if(season==='autumn'){
        sprite(ctx,'autumn-ground',96,457,110,-.05,.85);
        sprite(ctx,'autumn-ground',703,407,86,.07,.75);
      }
      if(season==='spring'){
        [[82,445,10,.2],[115,451,8,-.7],[345,449,9,1.4],[644,456,8,.4]].forEach(([x,y,w,a],i)=>sprite(ctx,i%2?'spring-petal-02':'spring-petal-01',x,y,w,a,.75));
      }
      if(season==='summer'&&night){
        for(let i=0;i<6;i++){
          const side=i<3?72:704;
          const x=side+Math.sin(t*.35+i*1.6)*43,y=340+(i%3)*26+Math.sin(t*.6+i)*13;
          const opacity=.15+.65*Math.pow((Math.sin(t*.8+i*1.9)+1)/2,2);
          sprite(ctx,'summer-firefly',x,y,40,0,opacity);
        }
        return;
      }
      if(season==='summer'){
        sprite(ctx,'summer-dapple',270+Math.sin(t*.3)*14,277,370,0,.30);
      }
      const n=reduced?Math.min(c.count,6):c.count;
      for(let i=0;i<n;i++){
        const seed=((i*137.508)%773)/773;
        const phase=(seed+t*c.speed*(.75+(i%4)*.13))%1;
        let x=((i*173+55+t*(season==='autumn'?18:8))%870)-45;
        x+=Math.sin(phase*7+i)*25+gust*22;
        const y=-115+phase*630;
        // Avoid visual noise over the small sign and its repaired background.
        if(x>520&&x<665&&y>290)continue;
        const alpha=Math.min(1,phase*8,(1-phase)*8)*(night?.84:.76);
        const rotation=Math.sin(t*.8+i)*.6+phase*(season==='autumn'?6:2);
        if(season==='spring')sprite(ctx,i%2?'spring-petal-02':'spring-petal-01',x,y,10+i%4*2,rotation,alpha,.55+.45*Math.abs(Math.sin(t*.75+i)));
        if(season==='summer')sprite(ctx,'summer-leaf',x,y,12+i%2*3,rotation,alpha*.5);
        if(season==='autumn')sprite(ctx,i%2?'autumn-leaf':'autumn-maple',x,y,16+i%3*3,rotation,alpha,.55+.45*Math.abs(Math.sin(t+i)));
        if(season==='winter')sprite(ctx,i%8===0?'winter-snowflake':'winter-snow-dot',x,y,i%8===0?13:7+i%4,rotation*.25,alpha);
      }
    }
    return {draw,ready};
  }
  const api={config,seasonForDate,periodForDate,nextPeriod,periodSwitchLabel,create};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  else global.HutSeasons=api;
})(typeof globalThis!=='undefined'?globalThis:this);
